import { useCheckAnyPermission } from '@/modules/auth/hooks/useCheckPermissions';
import type { Permission } from '@/modules/auth/permissions';

/**
 * Gate that checks if the user has any of the given permissions. Useful when you need to check if the user has at least one of the given permissions.
 */
export const AnyPermissionGate = ({
  permissions,
  children,
}: {
  permissions: Permission[];
  children: React.ReactNode;
}) => {
  const hasUserAnyPermission = useCheckAnyPermission();

  return hasUserAnyPermission(permissions) ? children : null;
};
